import { render, staticRenderFns } from "./ITStartup_4.vue?vue&type=template&id=34159611&"
import script from "./ITStartup_4.vue?vue&type=script&lang=js&"
export * from "./ITStartup_4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports